<template>
    <div v-if="showTag" class="info-quantity-tag" :style="{ backgroundColor }">
        <div class="info-quantity-tag__icon">
            <i :class="[icon, 'i-andy-s']" :style="{ color: textColor }"></i>
        </div>
        <div class="info-quantity-tag__text" :style="{ color: textColor }">
            <span class="info-quantity-tag__value" :style="{ color: textColor }">{{ normalizedValue }} </span>
            {{ $t(label) }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'InfoQuantityTag',
    props: {
        icon: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        value: {
            type: Number,
            default: 0
        },
        textColor: {
            type: String,
            default: '#000000'
        },
        backgroundColor: {
            type: String,
            default: '#FFFFFF'
        }
    },
    computed: {
        normalizedValue() {
            return Number(this.value) || 0
        },
        showTag() {
            return this.normalizedValue > 0
        }
    }
}
</script>

<style lang="scss" scoped>
.info-quantity-tag {
    display: inline-flex;
    @include align-items(center);
    gap: 4px;
    max-width: 100%;
    box-sizing: border-box;
    padding: 4px;
    border-radius: 4px;
    vertical-align: top;

    &__icon {
        @include display-flex();
        @include align-items(center);
        @include justify-content(center);
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }

    &__text {
        min-width: 0;
        font-family: $text;
        font-size: 12px;
        line-height: 16px;
    }

    &__value {
        font-family: $text-bold;
    }
}
</style>
